import { render } from "./Debugger.vue?vue&type=template&id=28d0b6d6&scoped=true"
import script from "./Debugger.vue?vue&type=script&lang=js"
export * from "./Debugger.vue?vue&type=script&lang=js"

import "./Debugger.vue?vue&type=style&index=0&id=28d0b6d6&scoped=true&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d0b6d6"]])

export default __exports__